jQuery(document).ready(function($) {

/* ------------------ GET THE COOKIE ------------------ */
    // Function after click close button
    function close_pop() {
      $('.c-modal-form').fadeOut();
      setCookie('signupclose', true, 30); //  days

      setTimeout(function () {
        $('.c-modal-form').removeClass('js-show');
      }, 1000);
      
      return false;
    }
    
    // Function after mail sent successfully
    function mail_sent() {
      setCookie('signupdone', true, 3650); // Infinito

      $('.c-modal-form .wpcf7-form > .c-modal-form__content').hide();

      setTimeout(function () {
        $('.c-modal-form').fadeOut();
        $('.c-modal-form').removeClass('js-show');
      }, 5000);

      return false;
    }

    // Run Function to display the modal
    $(document).ready(function () {
      displaySignupModal();
    });

    // Handles displaying the eye modal form.
    var displaySignupModal = function () {
      if (!getCookie('signupclose') && !getCookie('signupdone')) {
        $('.c-modal-form').addClass('js-show');
      } else {
        $('.c-modal-form').removeClass('js-show');
      }
    };

    // Click close button
    $(".c-modal-form .m-search-close").click(function () {
      close_pop();
    });


  // Fires when an Ajax form submission has completed successfully, and mail has been sent.
  jQuery(document).ajaxComplete(function() {
    if (jQuery(".c-modal-form .wpcf7-mail-sent-ok").length) {
      mail_sent();
    }
  });
}) // End jQuery

